import styled from "styled-components";

export const StyledFlex = styled.div`
  display: flex;
`;

export const StyledColumn = styled.div`
  display: flex;
  flex-direction: column;
`;
